import React, { Component } from 'react';
import { Box } from 'grommet/components/Box';
import { Anchor } from 'grommet/components/Anchor';
import { Image } from 'grommet/components/Image';
import logo from '../Assets/logoamexline.svg';
import { logout } from '../Utils/Utility';


class HeaderLogin extends Component {
  /*
  Useless since we don't use "this" in this component
  constructor(props) {
    super(props);
  }
  */


  render() {


    return (
      <Box id='header' direction='row' className='box-shadow2'>

        <Box style={{ position: 'static', padding: '0 20px', maxWidth: '1240px', margin: '0 auto', width: '1240px', display: 'inline' }}>
          <Anchor href='/' className='logo-link'>
            <Image id='logoheader2' style={{ verticalAlign: 'middle', float: 'left' }} src={logo} alt="logo" />
          </Anchor>
          <div id='marginlink' style={{ verticalAlign: 'middle', float: 'right', textDecoration: 'none', cursor: 'default' }}>
            <Anchor id='linkheader2' href='https://www.americanexpress.com/it/merchant/?inav=it_menu_business_merch_home' target='blank'>Esercizi Commerciali</Anchor>
            <Anchor id='linkheader' href='Esci' onClick={(e) => { e.preventDefault(); logout(); }}>Esci</Anchor>
          </div>
        </Box>

      </Box>
    );
  }
}

export default HeaderLogin;
